import React from 'react';
import {Field} from "formik";
import DataItem from '../../../_common/components/DataItem';
import DataItemTextarea from '../../../_common/components/DataItemTextarea';
import {floatValue, floatValueSign} from '../../../../../utils';
import styles from './styles.module.scss';

const InvoiceOrder = ({
                        days,
                        hours,
                        description,
                        amount,
                        vatIncluded,
                        viewMode = false,
                        buttonRemove
                      }) => {
  return (
    <div className={viewMode ? styles.itemView : styles.itemEdit}>
      <div className={styles.bodyCell}>
        <DataItem
          fieldId={days}
          onChange={floatValue}
          disabled={viewMode}
        />
      </div>
      <div className={styles.bodyCell}>
        <DataItem
          fieldId={hours}
          onChange={floatValue}
          disabled={viewMode}
        />
      </div>
      <div className={styles.bodyCell}>
        <DataItemTextarea
          fieldId={description}
          disabled={viewMode}
        />
      </div>
      <div className={styles.bodyCell}>
        <DataItem
          dir='ltr'
          customInputStyle='text-left custom-data-item'
          fieldId={amount}
          onChange={floatValueSign}
          disabled={viewMode}
        />
      </div>
      <div className={styles.bodyCell}>
        <Field
          name={vatIncluded}
        >
          {({field}) => (
            <>
              <input
                className='d-none custom-grid-checkbox'
                type='checkbox'
                checked={field.value}
                id={vatIncluded}
                disabled={viewMode}
                {...field}
              />
              <label
                htmlFor={vatIncluded}
                className={`custom-checkbox mb-0 custom-checkbox-size ${viewMode ? 'opacity-30' : ''}`}
              />
            </>
          )}
        </Field>
      </div>
      {buttonRemove}
    </div>
  )
};

InvoiceOrder.propTypes = {
};

export default InvoiceOrder;
